// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"495":"03bf95ae","758":"04534aca"}[chunkId] + ".chunk.css";
};